// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableLogging: true,
  APIEndpoint: 'http://localhost:7071/api/',
  //APIEndpoint: 'https://api.fusionworkflow.com/api/',
  //APIEndpointPROD: 'https://api.fusionworkflow.com/api/',
  APIEndpointPROD: 'https://api.fusionworkflow.com/api/',
  // Replace with your Google reCAPTCHA v2 site key (dev / localhost key)
  recaptchaSiteKey: '6Lcn1ZQsAAAAABhv3ZJyKMWkE_gEJNqk6EA1grzZ',
}
